var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C6.54822 0 3.75 2.79822 3.75 6.25V9.93402C3.75 9.99572 3.73174 10.056 3.69751 10.1074L1.5686 13.3008C1.36085 13.6124 1.25 13.9785 1.25 14.353C1.25 15.4007 2.09931 16.25 3.14699 16.25H16.853C17.9007 16.25 18.75 15.4007 18.75 14.353C18.75 13.9785 18.6391 13.6124 18.4314 13.3008L16.3025 10.1074C16.2682 10.056 16.25 9.99572 16.25 9.93402V6.25C16.25 2.79822 13.4517 0 10 0ZM5.625 6.25C5.625 3.83375 7.58375 1.875 10 1.875C12.4162 1.875 14.375 3.83375 14.375 6.25V9.93402C14.375 10.3659 14.5029 10.7881 14.7424 11.1474L16.8713 14.3407C16.8737 14.3444 16.875 14.3486 16.875 14.353C16.875 14.3558 16.8744 14.3591 16.8744 14.3591L16.8736 14.3612C16.8736 14.3612 16.8713 14.3659 16.8685 14.3685C16.8659 14.3713 16.8612 14.3736 16.8612 14.3736C16.8612 14.3736 16.8577 14.375 16.853 14.375H3.14699C3.14223 14.375 3.13871 14.3736 3.13871 14.3736C3.13871 14.3736 3.13411 14.3713 3.13144 14.3685C3.12878 14.3659 3.12634 14.3612 3.12634 14.3612C3.12634 14.3612 3.125 14.3577 3.125 14.353C3.125 14.3486 3.12629 14.3444 3.12869 14.3407L5.25761 11.1474C5.49716 10.7881 5.625 10.3659 5.625 9.93402V6.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4807 17.8119C12.3272 19.0454 11.2751 20 9.99999 20C8.72489 20 7.67277 19.0454 7.51925 17.8119C7.49794 17.6406 7.6399 17.5 7.81249 17.5H12.1875C12.3601 17.5 12.502 17.6406 12.4807 17.8119Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.e5a1f53f90b9a5c4a486213a2759e1b9.svg";
export { ForwardRef as ReactComponent };